import React from "react"
import ReactDOM from "react-dom/client"
// Antes do App: detecta o idioma (escolha salva > ?lang= > navegador > pt-BR) e ajusta o <html lang>.
import "./core/i18n"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
/*import { isWidget } from "./core/constants";

const elementId = isWidget()
  ? "checkout-affiliatespay"
  : "root";*/

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
